"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentLayout = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("@chakra-ui/react");
var Block_1 = require("./components/Block");
var fields_1 = require("../contents/fields");
var colmns_1 = require("../contents/colmns");
var Row_1 = require("./components/Row");
var ContentNotFound_1 = require("../error/ContentNotFound");
var ContentLayout = function (_a) {
    var contentBlocksData = _a.contentBlocksData;
    if (!contentBlocksData) {
        return (react_1.default.createElement(react_2.Box, { padding: "5rem" },
            react_1.default.createElement(ContentNotFound_1.ContentNotFound, null)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, contentBlocksData.map(function (blockData, blockIndex) { return (react_1.default.createElement(Block_1.Block, { key: "block-" + blockIndex, blockData: blockData }, blockData.rows.map(function (rowData, rowIndex) { return (react_1.default.createElement(Row_1.Row, { key: "row-" + blockIndex + rowIndex, rowData: rowData }, rowData.columns.map(function (columnData, columIndex) { return (react_1.default.createElement(colmns_1.Colmn, { key: "col-" + blockIndex + rowIndex + columIndex, columnData: columnData },
        react_1.default.createElement(fields_1.Field, { indexData: "" + blockIndex + rowIndex + columIndex, data: columnData.field }))); }))); }))); })));
};
exports.ContentLayout = ContentLayout;
